import React from 'react';

export function AboutPage({text, phone, email}) {
  return <div>
    HELLO
    <pre>{text}</pre>
    <div>{phone}</div>
    <div>{email}</div>
  </div>;
}